<template>
  <div>
    <b-row>
      <b-col>
        <success-fade-alert ref="successFadeAlert" :msg="alert.success" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </b-col>
    </b-row>
    <h2>Rotas</h2>
    <div>
      <router-link :to="`/checklist/route/save/`">
        <b-button size="sm">
          {{ $t("route.routeCreate") }}
        </b-button>
      </router-link>
    </div>

    <b-table
      ref="expenseTable"
      id="my-table"
      class="table-nowrap"
      :busy.sync="isBusy"
      :items="myProvider"
      :fields="fields"
      :per-page="tablePerPage"
      current-page="0"
      :filter.sync="tableFilters"
      :filter-debounce="500"
      :responsive="true"
    >
      <template v-slot:cell(actions)="data">
        <router-link :to="'/checklist/route/save/' + data.item.id">
          <b-button size="sm">{{ $t("geral.edit") }}</b-button>
        </router-link>
        <b-button
          v-if="data.item.active"
          variant="danger"
          class="ml-2"
          size="sm"
          @click="toggleActiveState(data.item.id)"
          >Desativar</b-button
        >
        <b-button
          v-else
          size="sm"
          @click="toggleActiveState(data.item.id)"
          class="ml-2"
          >Ativar</b-button
        >
      </template>
    </b-table>
    <table-pagination-props
      :currentPage.sync="tableCurrentPage"
      :pageOptions.sync="tablePageOptions"
      :perPage.sync="tablePerPage"
      :rowCount.sync="tableRowCount"
    >
    </table-pagination-props>
  </div>
</template>

<script>
export default {
  name: "RouteList",
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Rota salva com sucesso",
      },
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          sortable: false,
          label: "",
          thStyle: "width: 110px",
        },
        {
          key: "name",
          filterKey: "name",
          sortable: false,
          label: "Nome",
          thStyle: "width: 110px",
        },
        {
          key: "originCityName",
          filterKey: "originCityName",
          sortable: false,
          label: "Cidade de origem",
          thStyle: "width: 110px",
        },
        {
          key: "destinationCityName",
          filterKey: "destinationCityName",
          sortable: false,
          label: "Cidade de destino",
          thStyle: "width: 110px",
        },
        {
          key: "serviceTaker",
          filterKey: "serviceTaker",
          sortable: false,
          label: "Tomador de serviço",
          thStyle: "width: 110px",
        },
        {
          key: "sender",
          filterKey: "sender",
          sortable: false,
          label: "Remetente",
          thStyle: "width: 110px",
        },
        {
          key: "receiver",
          filterKey: "receiver",
          sortable: false,
          label: "Destinatário",
          thStyle: "width: 110px",
        },
        {
          key: "active",
          filterKey: "active",
          sortable: false,
          label: "Ativo",
          thStyle: "width: 110px",
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      tableFilters: {
        name: "",
        originCityId: 0,
        destinationCityId: 0,
        serviceTaker: "",
        sender: 0,
        receiver: 0,
        active: true,
      },
      optionsBoolean: [
        { value: null, text: "Todos" },
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableItems: [],
      isBusy: false,
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [10, 25, 50, 100, 150],
    };
  },
  methods: {
    myProvider(ctx, callback) {
      let apiFilter = {
        currentPage: this.tableCurrentPage,
        perPage: this.tablePerPage,
        name: ctx.filter.name,
        originCityId: ctx.filter.originCityId,
        destinationCityId: ctx.filter.destinationCityId,
        serviceTaker: ctx.filter.serviceTaker,
        sender: ctx.filter.sender,
        receiver: ctx.filter.receiver,
        active: ctx.filter.active,
      };
      this.$apiVehicle
        .post("/route/get/all/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableItems = [];
            callback([]);
          }
        });
      return null;
    },
    toggleActiveState(routeId) {
      this.$apiVehicle
        .post("/route/ToggleActiveState/" + routeId)
        .then((response) => {
          this.$refs.route.refresh();
          this.$forceUpdate();
          this.$refs.successFadeAlert.show();
        })
        .catch((error) => {
          this.$refs.fadeAlertDanger.show();
        });
    },
  },
  created() {
    // Lifecycle hook
  },
};
</script>

<style scoped>
/* Your styles here */
</style>